import React from "react";
import Link from "shared/components/Link";

import { URLS } from "apps/signup/util/constants";

import "./DesktopLoggedoutHeader.scss";

const DesktopLoggedoutHeader = () => (
	<div className="loggedout-header">
		<Link
			className="loggedout-header-logo"
			to={URLS.SPLASH}
			type="button"
		/>
	</div>
);

export default DesktopLoggedoutHeader;



// WEBPACK FOOTER //
// ./src/shared/components/DesktopLoggedoutHeader.jsx